import { NavLink as RouterNavLink, NavLinkProps } from "react-router-dom";
import { forwardRef, useMemo } from "react";
import { cn } from "@admin/lib/utils";
import { prefixRoute } from "../constants/routes";

interface NavLinkCompatProps extends Omit<NavLinkProps, "className"> {
  className?: string;
  activeClassName?: string;
  pendingClassName?: string;
}

const NavLink = forwardRef<HTMLAnchorElement, NavLinkCompatProps>(
  ({ className, activeClassName, pendingClassName, to, ...props }, ref) => {
    const prefixedTo = useMemo(() => {
      if (typeof to === "string") {
        return prefixRoute(to);
      }
      // For object-based to (e.g., { pathname: "/path", search: "?query" })
      if (typeof to === "object" && to !== null) {
        const pathname = to.pathname ?? "";
        return {
          ...to,
          pathname: prefixRoute(pathname),
        };
      }
      return to;
    }, [to]);

    return (
      <RouterNavLink
        ref={ref}
        to={prefixedTo}
        className={({ isActive, isPending }) =>
          cn(
            className,
            isActive && activeClassName,
            isPending && pendingClassName
          )
        }
        {...props}
      />
    );
  }
);

NavLink.displayName = "NavLink";

export { NavLink };
